import { render, staticRenderFns } from "./ScreenshotsList.vue?vue&type=template&id=0a8ecca6&"
import script from "./ScreenshotsList.vue?vue&type=script&lang=js&"
export * from "./ScreenshotsList.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ScreenshotsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports